import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {DataService} from "../../../services/data.service";
import {GlobalConstants} from "../../../common/global-constants";
import {ConfigurationService} from "../../../services/configuration.service";
import {forkJoin} from "rxjs";
import {AuthenticationService} from "../../../services/authentication.service";
import {CommonUtils} from "../../../utils/common.utils";

@Component({
  selector: 'app-previous-requests',
  templateUrl: './previous-requests.component.html',
  styleUrls: ['./previous-requests.component.scss']
})

export class PreviousRequestsComponent implements OnInit {

  fetchAllTransitTimeRequestsUrl: string = GlobalConstants.FETCH_ALL_TRANSIT_TIME_REQUESTS_ENDPOINT;
  approvalRequestUrl: string = GlobalConstants.SUBMIT_TRANSIT_TIME_APPROVAL_REQUEST_ENDPOINT;

  previousRequestsForm: FormGroup;

  loading = false;
  firstLoad = true;
  records: any[];

  fromCountryCodeOptions: any[];
  transitTimeOptions: string[];
  numberOfDaysOfHistoryOptions: number[];

  previousRequests = [];
  filteredPreviousRequests = [];

  countryCodes: any;

  currentComponentKeyPlaceholder = [];
  currentWorkingRecord: any;

  items: any;

  dropDownOptions: any;

  help_messages: any = this.dataService.help_messages;

  user = {};

  hasPermission = false;

  constructor(@Inject('RequestsService') private requestsService,
              @Inject('DataPathUtils') private dataPathUtils,
              @Inject('ConfigurationService') private readonly configurationService: ConfigurationService,
              @Inject('CommonUtils') private readonly commonUtils: CommonUtils,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private dataService: DataService) {
  }

  ngOnInit() {
    forkJoin(
      this.configurationService.getSettings(),
    ).subscribe(([settings]) => {
      this.user = this.authenticationService.getUserDetails();

      this.countryCodes = settings.countryCodes;
    });
    this.previousRequestsForm = this.formBuilder.group({
      businessUseCase: ['', Validators.required],
      fromCountryCode: ['', Validators.required],
      componentKeyPlaceholder: [''],
      componentKeyValue: ['', Validators.required],
      transitTimeType: ['', Validators.required],
      numberOfDaysOfHistory: ['', Validators.required]
    });
    this.fromCountryCodeOptions = this.commonUtils.getFromCountryCodes();
    this.transitTimeOptions = this.dataService.transitTimeOptions;
    this.numberOfDaysOfHistoryOptions = this.dataService.numberOfDaysOfHistoryOptions;

    this.items = this.commonUtils.getItemsBasedOnArc();
  }

  get getItems(){
    return this.commonUtils.getItemsBasedOnArc()
  }

  public onFromCountryCodeChange(fromCountryCode: string) {
    this.loading = true;
    this.currentWorkingRecord = {};

    this.previousRequestsForm.get(GlobalConstants.BUSINESS_USE_CASE).setValue('');
    this.previousRequestsForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue('')
    this.currentComponentKeyPlaceholder = [];
    this.dataService.getConfigurationRecordsBasedOnFromCountryCode(fromCountryCode).subscribe((data: any[]) => {
      this.loading = false;
      this.records = data[GlobalConstants.TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY];
      console.log(data)
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }





  public onBusinessUseCaseChange(businessUseCase) {
    this.currentWorkingRecord = this.commonUtils.getCurrentWorkingRecord(businessUseCase);
    this.dropDownOptions = this.commonUtils.getDropDownOptions(this.currentWorkingRecord, this.records);
    this.previousRequests = [];

    this.previousRequestsForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue(this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER])
    this.currentComponentKeyPlaceholder = this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER].split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
    this.previousRequestsForm.setControl(GlobalConstants.COMPONENT_KEY_VALUE, this.getComponentKeyValueFormGroup());

    this.previousRequestsForm.get(GlobalConstants.TRANSIT_TIME_TYPE).setValue('');
  }

  private getComponentKeyValueFormGroup() {
    let componentKeyPlaceValueFormGroupInput = {};
    for (let componentKey of this.currentComponentKeyPlaceholder) {
      componentKeyPlaceValueFormGroupInput[componentKey] = new FormControl('', Validators.required)
    }
    return this.formBuilder.group(componentKeyPlaceValueFormGroupInput);
  }

  public async render() {
    this.firstLoad = false;
    this.loading = true;
    this.hasPermission = false;
    let requestBody = JSON.parse(JSON.stringify(this.previousRequestsForm.value));
    requestBody[GlobalConstants.BUSINESS_UNIT] = this.currentWorkingRecord[GlobalConstants.BUSINESS_UNIT];
    requestBody[GlobalConstants.COMPONENT_KEY_VALUE] = this.commonUtils.buildComponentKeyValue(requestBody[GlobalConstants.COMPONENT_KEY_VALUE], requestBody[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]);
    requestBody[GlobalConstants.CREATED_BY] = this.user[GlobalConstants.ALIAS];
    try {
      this.loading = true;
      this.hasPermission = await this.dataService.checkUserPermissions(requestBody);
      this.loading = false;
      if (this.hasPermission === false){
        this.toastrService.error(GlobalConstants.NO_PERMISSION_MSG, GlobalConstants.TITLE_ERROR);
        return;
      } 
    } catch (error) {
      this.loading = false;
      console.error(GlobalConstants.CHECK_USER_PERMISSIONS_ERROR, error)
      this.toastrService.error(GlobalConstants.SOMETHING_WENT_WRONG, GlobalConstants.TITLE_ERROR);
      return;
    }
    this.loading = true;
    this.requestsService.put(this.fetchAllTransitTimeRequestsUrl, requestBody).subscribe(data => {
      this.loading = false;
      this.previousRequests = data[GlobalConstants.TRANSIT_TIME_REQUESTS_RESPONSE_KEY];
      this.filteredPreviousRequests = [];
      let arc = this.commonUtils.getArc();
      for (let record in this.previousRequests) {
        if (this.previousRequests[record][GlobalConstants.ARC] == undefined || this.previousRequests[record][GlobalConstants.ARC] == arc) {
          this.filteredPreviousRequests.push(this.previousRequests[record]);
        }
      }
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

}
